import React from 'react';
import { useTheme } from '@material-ui/core/styles';

const withTheme = () => WrappedComponent => props => {
  const theme = useTheme();
  return <WrappedComponent {...props} theme={theme} />;
};

export default withTheme;
